"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumn = exports.convertAlignmentToClass = exports.Alignment = exports.WidthType = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var WidthType;
(function (WidthType) {
    WidthType["AUTO"] = "auto";
    WidthType["PX"] = "px";
    WidthType["PERCENT"] = "%";
})(WidthType = exports.WidthType || (exports.WidthType = {}));
var Alignment;
(function (Alignment) {
    Alignment["START"] = "start";
    Alignment["CENTER"] = "center";
    Alignment["END"] = "end";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
var convertAlignmentToClass = function (alignment) {
    var classPrefix = 'tabular-content__cell__container';
    if (!alignment || alignment === Alignment.START) {
        return classPrefix + "--start";
    }
    if (alignment === Alignment.CENTER) {
        return classPrefix + "--center";
    }
    return classPrefix + "--end";
};
exports.convertAlignmentToClass = convertAlignmentToClass;
var TableColumn = function (_a) {
    var children = _a.children, alignment = _a.alignment;
    var tableCellClasses = (0, classnames_1.default)('tabular-content__cell', 'tabular-content__cell--header');
    var tableCellContainerClasses = (0, classnames_1.default)('tabular-content__cell__container', (0, exports.convertAlignmentToClass)(alignment));
    return (React.createElement("th", { className: tableCellClasses },
        React.createElement("div", { className: tableCellContainerClasses }, children)));
};
exports.TableColumn = TableColumn;
exports.TableColumn.defaultProps = {
    alignment: Alignment.START,
    widthType: WidthType.AUTO,
    widthValue: 0,
};
exports.TableColumn.propTypes = {
    alignment: PropTypes.oneOf(Object.values(Alignment)),
    widthType: PropTypes.oneOf(Object.values(WidthType)),
    widthValue: PropTypes.number,
};
